/* @flow */
import React, { PropTypes } from 'react';
import { InvoiceService } from 'frilans-finans';
import axios from 'axios';
import Translate from 'react-translate-component';

import Invoicing from '../../../components/invoice-details/invoicing';
import Specification from '../../../components/invoice-details/specification';
import Dates from '../../../components/invoice-details/dates';
import Amount from '../../../components/invoice-details/amount';
import Outlays from '../../../components/invoice-details/outlays';
import Workers from '../../../components/invoice-details/workers';
import Rewards from '../../../components/invoice-details/rewards';

export class Invoice extends React.Component {

  static propTypes = {
    params: PropTypes.object
  };

  static contextTypes = {
    user: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired
  };

  constructor (props, context) {
    super(props, context);

    this.state = {
      invoice: null,
      outlays: [],
      user: context.user,
      fetching: true,
      fetchError: false
    };

    this.fetchData = this.fetchData.bind(this);
  }

  componentDidMount () {
    this.fetchData();
  }

  fetchData () {
    axios.all([
      InvoiceService.getById(this.props.params.id),
      InvoiceService.getSupplierLedgersForInvoice(this.props.params.id)
    ])
      .then(axios.spread(this.handleAPIResponse.bind(this)))
      .catch(() => {
        this.setState({
          fetching: false,
          fetchError: true
        });
      });
  }

  handleAPIResponse (invoice, outlays) {
    this.setState({
      invoice: invoice,
      outlays: outlays,
      fetching: false,
      fetchError: false
    });
  }

  renderPDFButton () {
    if (this.state.invoice && this.state.invoice.pdfLink) {
      return (
        <a href={this.state.invoice.pdfLink} target='_blank' className='btn'>
          <Translate content='DOWNLOAD_AS_PDF' />
        </a>
      );
    }
  }

  render () {
    if (!this.state.fetching && this.state.invoice) {
      return (
        <div className='invoice-details-container'>
          <Invoicing
            invoice={this.state.invoice}
            user={this.context.user}
          />
          <Specification invoice={this.state.invoice} />
          <Dates invoice={this.state.invoice} />
          <Amount invoice={this.state.invoice} />
          <Outlays
            outlays={this.state.outlays}
            showDetailColumns
          />
          <Workers
            invoice={this.state.invoice}
            outlays={this.state.outlays}
            user={this.state.user}
          />
          <Rewards invoice={this.state.invoice} />
          {this.renderPDFButton()}
        </div>
      );
    }
    return <div></div>;
  }
}

export default Invoice;



/** WEBPACK FOOTER **
 ** ./src/views/economy-view/invoices/invoice.js
 **/